import React, { PropsWithChildren } from 'react';
import { PiletApi, PiletUserContext } from '@sharefiledev/sharefile-appshell';
import { Spin } from 'antd';
import { LocalizationLoader } from '../translate';
import { useLabels } from './useLabels';

export interface IExtensionContext extends PiletUserContext {
	piletApi: PiletApi;
	t: (key: string, options?: any) => string;
	labels?: [
		string,
		{
			en?: string;
		}
	][];
}

const ExtensionContext = React.createContext<IExtensionContext>({} as any);

export interface ExtensionsContextProviderProps extends PropsWithChildren {
	piletApi: PiletApi;
	labels?: [
		string,
		{
			en?: string;
		}
	][];
}
export const ExtensionsContextProvider: React.FC<ExtensionsContextProviderProps> = ({
	children,
	piletApi,
	labels,
}) => {
	const userContext = piletApi.sf.piletUserContext.get();
	const t = useLabels(labels);

	return (
		<ExtensionContext.Provider value={{ piletApi, ...userContext, t, labels }}>
			<LocalizationLoader loadingElement={<Spin />}>
				{(): JSX.Element => children as JSX.Element}
			</LocalizationLoader>
		</ExtensionContext.Provider>
	);
};

export function useExtensionContext() {
	return React.useContext(ExtensionContext);
}
